import * as toastr from 'toastr';

// tslint:disable-next-line
// took from https://github.com/pburtchaell/redux-promise-middleware/blob/master/examples/complex/middleware/error.js as an example
function errorMiddleware() {
	return (store: any) => (next: any) => (action: any) => {
		const result = next(action);

		if (!isPromise(result)) {
			return result;
		}

		return result.catch((error: any) => {
			let message = error.message ? JSON.stringify(error.message) : JSON.stringify(error);
			console.warn(`${action.name} caught at middleware with reason: ${message}.`);
			toastr.error('Sorry something went wrong!');
			throw error;
		});
	};
}
function isPromise(value: any) {
	if (value !== null && typeof value === 'object') {
		return value && typeof value.then === 'function';
	}

	return false;
}

export default errorMiddleware;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/errorMiddleware.ts